/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import type { Adresse } from './Adresse';
import type { Prepose } from './Prepose';

/**
 * These identify the different param modals on the parameter page
 */
export enum Parametres {
  Generaux = 'parametres-generaux',
  Utilisateur = 'utilisateur',
  Profession = 'profession',
  Scolarite = 'scolarite',
  MessagesTypes = 'messages-types',
}

export type ParametresGeneraux = {
  identifiant?: number;
  identifiantEntite: number;
  identifiantAdresseMairie: number;
  identifiantCiviliteMaire: number;
  nomCommune: string;
  nomMaire: string;
  telephone1: string;
  telephone2: string;
  libelleArrondissement: string;
  codeArrondissement: number;
  adresseEmail: string;
  numeroFichierPecoto: number;
  versionFichierPecoto: number;
  dernierEnvoiPecoto: string;
  apiHubeeLiaisonActive: boolean;
  apiHubeeUrl: string;
  apiHubeeVersion: string;
  apiHubeeToken: string;
  apiHubeeLogin: string;
  apiHubeeMdp: string;
  prepose: Prepose;
  imageCachet?: string;
  cheminCachet?: string;
  imageSignature?: string;
  cheminSignature?: string;
  adresse: Adresse;
  stockageObjetCachet?: string;
  stockageObjetSignature?: string;
};
